import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "../../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";

import useArchiveConversationForm from "./useArchiveConversationForm";
import ArchiveConversationForm from "./ArchiveConversationForm";

export default ArchiveConversation;

function ArchiveConversation(props) {
  const { node, closePanel, onSave, validationErrors } = props;

  const { formState, errors, updateFormState, validate } =
    useArchiveConversationForm(node.data, validationErrors);

  const handleSave = () => {
    if (!validate()) {
      return;
    }

    onSave(node.id, {
      ...node.data,
      ...formState,
    });

    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure Archive Conversation</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <ArchiveConversationForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end items-center gap-x-2">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
